<template>
	<el-dialog
		:title="`${title}${isSingleCheck ? '（单选）' : ''}`"
		:visible.sync="dialogVisible"
		:append-to-body="isAppendToBody"
		@close="cancel"
		width="60%"
		:modal="false"
	>
		<div class="content" v-loading="generalLoading">
			<div class="left">
				<div class="search-bar">
					<el-input
						class="search-input"
						prefix-icon="el-icon-search"
						placeholder="输入关键字搜索"
						size="mini"
						v-model="searchValue"
						clearable
						@clear="resetList"
					/>
					<el-button class="search-button" type="text" size="small" @click="searchList">搜索</el-button>
					<el-button class="search-button" type="text" size="small" @click="resetList">重置</el-button>
				</div>
				<div class="breadcrumbs">
					<i class="el-icon-office-building"></i>
					<el-tooltip v-if="crumbList.length" effect="dark" :content="crumbList.map((e) => e.label).join(' > ')" placement="top">
						<div class="crumb-str text-ellipsis">{{ crumbList.map((e) => e.label).join(' > ') }}</div>
					</el-tooltip>
					<div class="crumb-str text-ellipsis" v-else>请从列表中选择数据</div>
				</div>
				<div class="list" v-loading="listLoading">
					<div class="check-all">
						<el-checkbox v-model="currentCheckedAll" :indeterminate="indeterminateAll" @change="checkedAllChange" :disabled="isSingleCheck"
							>全选</el-checkbox
						>
						<el-button
							type="text"
							style="margin-left: 20px"
							:style="{
								marginLeft: '20px',
								visibility: crumbList.length > 1 || (crumbList.length && crumbList[0].code !== rootDeptCode) ? 'visible' : 'hidden',
							}"
							@click="prevLevel"
							>上一级</el-button
						>
					</div>
					<div class="list-item" :ref="`listItem${index}`" v-for="(item, index) of list" :key="index">
						<el-checkbox
							:class="[item.disabledColorNormal && 'user-dept-checkbox']"
							v-model="item.checked"
							:indeterminate="item.indeterminate"
							@change="() => checkedChange(item, false)"
							:disabled="item.disabled"
						>
							<div class="checkbox-label" :ref="`listItemCheckLabel${index}`">
								<i :class="item.icon" style="margin-right: 5px"></i>
								<span>{{ item.label }}</span>
							</div>
						</el-checkbox>
						<el-button type="text" :style="{ marginLeft: '20px', visibility: !item.leaf ? 'visible' : 'hidden' }" @click="nextLevel(item)"
							>下一级</el-button
						>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="total-bar">
					<span>已选 {{ checkedList.length }} 项</span>
					<span @click="clearAllChecked">清空</span>
				</div>
				<div class="checked-list" v-loading="checkedListLoading">
					<template v-if="checkedList.length">
						<div class="checked-list-item" v-for="(item, index) of checkedList" :key="index">
							<span>{{ item.showCheckedName }}</span>
							<i class="el-icon-close" @click="deleteThisChecked(item)"></i>
						</div>
					</template>
					<div class="empty-box" v-else>
						<el-empty description="请点击左侧列表选择数据"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer">
			<el-button @click="cancel" size="small">取 消</el-button>
			<el-button type="primary" @click="submit" size="small">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { getAction } from '@/utils'
export default {
	name: 'OrgPicker',
	props: {
		// 标题
		title: {
			type: String,
			default: '',
		},
		// 是否显示弹框
		showOrgPicker: {
			type: Boolean,
			default: false,
		},
		// 是否显示到人员级别
		isPersonLevel: {
			type: Boolean,
			default: false,
		},
		// 已选:
		// [deptCode, deptCode, ...] 或 [deptCode-userId, deptCode-userId, ...] 或 [userId, userId, ...]
		checkedData: {
			type: Array,
			default: () => {
				return [];
			},
		},
		// 部门及子部门、部门内部人员可选：
		// [deptCode, deptCode, ...]
		enableDeptData: {
			type: Array,
			default: () => {
				return [];
			},
		},
		// 内部人员可选：
		// [deptCode-userId, deptCode-userId, ...] 或 [userId, userId, ...]
		enableUserData: {
			type: Array,
			default: () => {
				return [];
			},
		},
		// 是否只能选择叶子节点
		isCheckLeafOnly: {
			type: Boolean,
			default: false,
		},
		// 是否单选
		isSingleCheck: {
			type: Boolean,
			default: false,
		},
		// 是否嵌入body
		isAppendToBody: {
			type: Boolean,
			default: false,
		},
		// 不同部门相同用户是否合并(userId相同，deptCode不同)
		isMergeUser: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		async showOrgPicker(v) {
			this.dialogVisible = v;
			if (v) {
				this.generalLoading = true;
				let deptParents = [];
				let userParents = [];
				this.enableParents = [];
				// 获取所有可选部门的父级，为了设置父级部门禁选，但设置正常色（表示存在子部门可选）
				if (this.enableDeptData?.length) {
					deptParents = await this.getParentDeptInfo(this.enableDeptData.join(','));
				}
				// 获取所有可选人员的父级（包括人员所在部门），为了设置父级部门禁选，但设置正常色（表示存在人员可选）
				if (this.isPersonLevel && this.enableUserData?.length) {
					let enableUserDeptCodes = [];
					if (this.enableUserData[0].indexOf('-') > -1) {
						// deptCode-userId格式
						enableUserDeptCodes = this.enableUserData.map((e) => e.split('-')[0]);
						// 去重
						enableUserDeptCodes = [...new Set(enableUserDeptCodes)];
					} else {
						// userId格式
						enableUserDeptCodes = await this.getUserDeptCodesByUserIds(this.enableUserData.join(','));
					}
					// 获取用户部门的父级部门
					userParents = await this.getParentDeptInfo(enableUserDeptCodes.join(','));
					// 合并用户的部门（部门也是用户的父级）
					userParents = userParents.concat(enableUserDeptCodes);
				}
				this.enableParents = deptParents.concat(userParents);
				// 去重
				this.enableParents = [...new Set(this.enableParents)];
				// 初始化列表
				this.resetList().then(() => {
					// 获取回显数据
					if (this.checkedData.length) {
						let request;
						let params;
						if (this.isPersonLevel) {
							// 显示到人员级别
							if (this.checkedData[0].indexOf('-') > -1) {
								// 区分部门的同一人员
								request = this.getUserInfoByCodeList;
								params = this.checkedData.map((e) => {
									return {
										deptCode: e.split('-')[0],
										userId: e.split('-')[1],
									};
								});
							} else {
								// 不区分部门的人员
								request = this.getUserInfoByUserIdList;
								params = {
									userIdList: this.checkedData.join(','),
								};
							}
						} else {
							request = this.getOrgTree;
							params = {
								deptCodes: this.checkedData.join(','),
							};
						}
						// 调接口
						this.getAlreadyCheckList(request, params).then(() => {
							this.generalLoading = false;
						});
					} else {
						this.checkedList = [];
						// 刷新选中状态
						this.validListItemChecked();
						this.generalLoading = false;
					}
				});
			}
		},
	},
	data() {
		return {
			generalLoading: false,
			dialogVisible: false, // 弹框是否显示
			crumbList: [], // 面包屑列表
			searchValue: '', // 搜索栏
			listLoading: false,
			list: [], // 选择列表
			currentCheckedAll: false, // 当前层级是否全选
			indeterminateAll: false, // 全选状态-半选
			checkedListLoading: false,
			checkedList: [], // 选中列表
			enableParents: [], //可选项的所有父级
			userSystemList: [
                {
                    value: 'zzd',
                    label: '浙政钉',
                    icon: require('@/assets/zzdIcon.png'),
                },
                {
                    value: 'dd',
                    label: '钉钉',
                    icon: require('@/assets/ddIcon.png'),
                },
				{
                    value: 'zc',
                    label: '注册',
                    icon: require('@/assets/zcIcon.png'),
                },

            ],
			userSystemMap: {
				0: 'zc',
                1: 'zzd',
                2: 'dd',
				zc: 0,
                zzd: 1,
                dd: 2,
            },
		};
	},
	computed: {
		rootDeptCode() {
			return this.$attrs.option.config.VUE_APP_DEPTCODE
		},
	},
	methods: {
		/** ----------------------------------调接口---------------------------------- */
		// 获取组织树
		getOrgTree(params) {
			return new Promise((resolve) => {
                const { option: { api } } = this.$attrs
                if(!api.getOrgTree) return Promise.reject('no api')
				const [action, otherParams] = getAction(api.getOrgTree)
				action({...params, ...otherParams}).then((res) => {
					resolve(
						res.data.map(
							({
								deptCode: code,
								deptName: label,
								parentCode: pCode,
								parentName: pName,
								path: deptPath,
								department: showCheckedName,
								leaf,
								sourceType,
							}) => {
								let newLeaf = this.isPersonLevel ? false : leaf; // 显示到人员级别，则部门都是非叶子节点
								let disabled = false;
								let disabledColorNormal = false;
								// 是否限定了可选部门/人员范围
								if (this.enableDeptData?.length || (this.isPersonLevel && this.enableUserData?.length)) {
									// 根据部门设置是否可选-enableDeptData包含的部门和其子部门
									const deptPathChain = deptPath.split('/').filter((e) => e);
									disabled = deptPathChain.every((e) => !this.enableDeptData.includes(e)); // 部门path里面都不包含传入deptCode则true
									// 可选部门的父级部门，设置正常色（但是禁选），说明内部有子部门可以选择
									if (this.enableParents.includes(code)) {
										disabledColorNormal = true;
									}
									// 如果是显示到人员级别，部门会全部置灰。就把可选的部门设置正常色，说明内部有人员可以选择
									if (this.isPersonLevel && !disabled) {
										disabledColorNormal = true;
									}
									// 如果只能选择叶子节点，则非叶子节点会全部置灰。就把可选的部门设置正常色，说明内部有叶子节点可以选择
									if (this.isCheckLeafOnly && !newLeaf && !disabled) {
										disabledColorNormal = true;
									}
								} else {
									// 无任何禁止时，部门设置正常色
									disabledColorNormal = true;
								}
								if (this.isPersonLevel) {
									// 显示到人员级别，部门禁选
									disabled = true;
								} else if (this.isCheckLeafOnly && !newLeaf) {
									// 只能选择叶子节点，非叶子节点的部门禁选
									disabled = true;
								}
								return {
									code, // 部门编码
									label: `[${this.userSystemList.find((e) => e.value === this.userSystemMap[sourceType])?.label}]${label}`, // 部门名称
									originDeptName: label,
									pCode: params.parentCode === this.rootDeptCode ? null : pCode, // 父级编码-顶层删除父级
									pName: params.parentCode === this.rootDeptCode ? null : pName, // 父级名称-顶层删除父级
									leaf: newLeaf, // 是否是叶子节点
									sourceType, // 来源
									flag: 'department', // 部门标记
									disabled, // 选择人员的时候，部门禁选
									disabledColorNormal, // 虽然禁选，但是还是部门标记正常颜色。
									checked: false, // 是否选中，默认不选中
									deptPath,
									showCheckedName: `[${this.userSystemList.find((e) => e.value === this.userSystemMap[sourceType])?.label}]${showCheckedName}`, // 选中列表显示的命名字：爷爷名称-爸爸名称-本级名称
									icon: 'el-icon-folder-opened',
								};
							}
						)
					);
				});
			});
		},
		// 根据部门codes获取部门组,有department
		getLargeDeptsByCodes(deptCodes) {
			return new Promise((resolve) => {
                const { option: { api } } = this.$attrs
                if(!api.getLargeDeptsByCodes) return Promise.reject('no api')
				const [action, otherParams] = getAction(api.getLargeDeptsByCodes)
				action({
					deptCodes,
					...otherParams
				}).then((res) => {
					resolve(
						res.data.map(({ deptCode: code, department: showCheckedName, path, sourceType }) => {
							return {
								code, // 部门编码
								path, // 部门编码路径
								showCheckedName: `[${this.userSystemList.find((e) => e.value === this.userSystemMap[sourceType])?.label}]${showCheckedName}`, // 选中列表显示的命名字：爷爷名称-爸爸名称-本级名称
							};
						})
					);
				});
			});
		},
		// 搜索用户（获取部门人员）
		getUserSearch(params, type) {
			return new Promise((resolve) => {
                const { option: { api } } = this.$attrs
                if(!api.getUserSearch) return Promise.reject('no api')
				const [action, obj] = getAction(api.getUserSearch)
				action({...params, ...obj}).then((res) => {
					let newArr = [];
					res.data.forEach((e) => {
						e.positions.forEach((x) => {
							newArr.push({ ...e, ...x });
						});
					});
					const isSearch = type === 'search';
					if (!isSearch) {
						// 非搜索-接口返回部门及以下所有人员，所以要筛选以下本级本部门的人员
						newArr = newArr.filter((e) => e.deptCode === params['deptCode']);
					}
					if (newArr.length) {
						this.handleUserDataList(newArr).then((list) => {
							resolve(list);
						});
					} else {
						resolve([]);
					}
				});
			});
		},
		// 根据userIds获取部门code和name
		getUserInfoByUserIdList(params) {
			return new Promise((resolve) => {
                const { option: { api } } = this.$attrs
                if(!api.getUserInfoByUserIdList) return Promise.reject('no api')
				const [action, otherParams] = getAction(api.getUserInfoByUserIdList)
				action({...params, ...otherParams}).then((res) => {
					if (res.data.length) {
						this.handleUserDataList(res.data).then((list) => {
							resolve(list);
						});
					} else {
						resolve([]);
					}
				});
			});
		},
		// 根据userIds获取部门code
		async getUserDeptCodesByUserIds(userIdList) {
            const { option: { api } } = this.$attrs
            if(!api.getUserInfoByUserIdList) return []
			const [action, otherParams] = getAction(api.getUserInfoByUserIdList)
			const { data } = await action({ userIdList, ...otherParams });
			const list = data.map((e) => e.deptCode);
			// 去重
			return [...new Set(list)];
		},
		// 根据userId和deptCode数组获取人员信息
		getUserInfoByCodeList(params) {
			return new Promise((resolve) => {
                const { option: { api } } = this.$attrs
                if(!api.getUserInfoByCodeList) return Promise.reject('no api')
				const [action] = getAction(api.getUserInfoByCodeList)
				action(params).then((res) => {
					if (res.data.length) {
						this.handleUserDataList(res.data).then((list) => {
							resolve(list);
						});
					} else {
						resolve([]);
					}
				});
			});
		},
		// 获取传入部门的所有父级部门code
		async getParentDeptInfo(deptCodes) {
            const { option: { api } } = this.$attrs
            if(!api.getParentDeptInfo) return []
			const [action, params] = getAction(api.getParentDeptInfo)
			const list = [];
			const { data = [] } = await action({
				deptCodes,
				...params
			});
			data.forEach((e) => {
				e.path
					.split('/')
					.filter((x) => x)
					.forEach((x) => {
						if (!list.includes(x)) {
							list.push(x);
						}
					});
			});
			return list;
		},
		/** ----------------------------------调接口---------------------------------- */
		/** ----------------------------------处理---------------------------------- */
		// 动态设置list-item的padding，文字单行不用间隔；多行文字要设置间隔，单行文本的高度是19px
		setListItemPadding(index) {
			this.$nextTick(() => {
				const height = this.$refs[`listItemCheckLabel${index}`][0].clientHeight;
				if (height > 19) {
					this.$refs[`listItem${index}`][0].style.padding = '8px 5px';
				}
			});
		},
		// 人员数组处理
		handleUserDataList(list) {
			return new Promise((resolve) => {
				let newArr = list.map(({ userId, username: label, deptCode: userDeptCode, deptName: userDeptName, mobile, sourceType }) => {
					return {
						code: `${userDeptCode}-${userId}`,
						label: `[${this.userSystemList.find((e) => e.value === this.userSystemMap[sourceType])?.label}]${label}`, // 人员名称
						originUserName: label,
						userDeptCode,
						userDeptName,
						mobile,
						userId,
						sourceType,
						checked: false,
						leaf: true,
						flag: 'user',
						icon: 'el-icon-user',
					};
				});
				// 返回人员的部门组
				let deptCodeList = Array.from(new Set(newArr.map((e) => e.userDeptCode)));
				// 补齐人员层级链
				this.getLargeDeptsByCodes(deptCodeList).then((deptList) => {
					newArr.forEach((user) => {
						user.userDeptCodePath = deptList.find((x) => x.code === user.userDeptCode)?.path;
						user.showCheckedName = deptList.find((x) => x.code === user.userDeptCode)?.showCheckedName + '-' + user.originUserName; // 选中列表显示的命名字：爷爷名称-爸爸名称-本级名称
					});
					// 注：先判断人-再判断部门，倒过来则部门设置的会被重置，部门enableDeptData就失效了
					/**---------------------------------------------------------- */
					// 根据人员设置是否可选
					if (this.enableUserData?.length) {
						if (this.enableUserData[0].indexOf('-') > -1) {
							newArr.forEach((e) => {
								e.disabled = true;
								this.enableUserData.forEach((x) => {
									if (e.userId === x.split('-')[1] && e.userDeptCode === x.split('-')[0]) {
										e.disabled = false;
									}
								});
							});
						} else {
							newArr.forEach((e) => {
								e.disabled = !this.enableUserData.includes(e.userId);
							});
						}
					}
					// 根据部门设置是否可选（父级部门可选，则子部门可选）
					if (this.enableDeptData?.length) {
						newArr.forEach((x) => {
							const deptPathChain = x.userDeptCodePath.split('/').filter((e) => e);
							x.disabled = deptPathChain.every((e) => !this.enableDeptData.includes(e)); // 部门path里面都不包含传入deptCode则true
						});
					}
					/**---------------------------------------------------------- */
					resolve(newArr);
				});
			});
		},
		// 获取组织树之后，并完成处理
		getTreeComplete(deptParams, userParams, type) {
			return new Promise((resolve) => {
				this.listLoading = true;
				let PromiseFunc;
				if (this.isPersonLevel) {
					// 显示到人员级别
					PromiseFunc = Promise.all([this.getOrgTree(deptParams), this.getUserSearch(userParams, type)]);
				} else {
					PromiseFunc = this.getOrgTree(deptParams);
				}
				PromiseFunc.then((res) => {
					this.list = [];
					if (this.isPersonLevel) {
						// 显示到人员级别
						this.list = res[0].concat(res[1]);
					} else {
						this.list = res;
					}
					if (type === 'search') {
						this.list.forEach((item) => {
							// 路过是搜索，显示路径
							item.isSearch = true;
							item.labelReal = item.label;
							item.label = item.showCheckedName;
							return item;
						});
					}
					// 设置一下行间距，单行不挤，多行很挤，需要间隔一下
					this.list.forEach((e, i) => {
						this.setListItemPadding(i);
					});
					// 刷新选中状态
					this.validListItemChecked();
					this.listLoading = false;
					resolve();
				});
			});
		},
		// 写入回显checkList
		getAlreadyCheckList(request, params) {
			return new Promise((resolve) => {
				this.checkedListLoading = true;
				request(params).then((list) => {
					this.checkedList = list.map((e) => {
						e.checked = true; // 选中列表，都是选中的
						return e;
					});
					// 刷新选中状态
					this.validListItemChecked();
					this.checkedListLoading = false;
					resolve();
				});
			});
		},
		// 校验list每个的选中状态
		validListItemChecked() {
			const checkedCodes = this.checkedList.map((e) => e.code);
			if (checkedCodes.length) {
				// 判断列表项的选中状态
				this.list.forEach((e) => {
					e.checked = checkedCodes.includes(e.code);
				});
				// 判断全选状态
				const listLength = this.list.filter((e) => !e.disabled).length;
				const listCheckedLength = this.list.filter((e) => !e.disabled).filter((e) => e.checked).length;
				if (listLength === listCheckedLength && listCheckedLength > 0) {
					this.currentCheckedAll = true;
					this.indeterminateAll = false;
				} else if (listLength > listCheckedLength && listCheckedLength > 0) {
					this.currentCheckedAll = false;
					this.indeterminateAll = true;
				} else {
					this.currentCheckedAll = false;
					this.indeterminateAll = false;
				}
			} else {
				// 全部清除选中
				this.list.forEach((e) => {
					e.checked = false;
				});
				this.currentCheckedAll = false; // 当前层级是否全选
				this.indeterminateAll = false; // 全选状态-半选
			}
		},
		/** ----------------------------------处理---------------------------------- */
		/** ----------------------------------按钮---------------------------------- */
		// 搜索
		searchList() {
			// 清空面包屑
			this.crumbList = [];
			if (this.searchValue) {
				this.getTreeComplete(
					{
						deptName: this.searchValue,
					},
					{
						username: this.searchValue,
					},
					'search'
				);
			} else {
				this.resetList();
			}
		},
		// 重置
		resetList() {
			return new Promise((resolve) => {
				this.searchValue = '';
				this.getTreeComplete(
					{
						parentCode: this.rootDeptCode,
					},
					{
						deptCode: this.rootDeptCode,
					}
				).then(() => {
					this.crumbList = [];
					resolve();
				});
			});
		},
		// 上一级
		prevLevel() {
			// 面包屑减少一级
			const currentItem = this.crumbList.pop();
			// 获取上一级数据
			this.getTreeComplete(
				{
					parentCode: currentItem?.pCode || this.rootDeptCode,
				},
				{
					deptCode: currentItem?.pCode || this.rootDeptCode,
				}
			);
		},
		// 下一级
		nextLevel(item) {
			// 面包屑新增一级
			this.crumbList.push(item);
			// 获取下一级数据
			this.getTreeComplete(
				{
					parentCode: item.code,
				},
				{
					deptCode: item.code,
				}
			);
		},
		// 切换选中状态
		checkedChange(item, checkAllFlag) {
			const { max } = this.$attrs
			if(item.checked && this.checkedList.length + 1 > max) {
				item.checked = false
				this.$message.warning('最多选择' + max + '项，请重新选择')
				return
			}
			return new Promise((resolve) => {
				if (this.isSingleCheck) {
					// 单选，list其他都不选中
					this.list
						.filter((e) => !e.disabled)
						.forEach((e) => {
							if (e.code !== item.code) {
								e.checked = false;
							}
						});
				}
				if (item.checked) {
					// 写入新存入的选项
					if (this.isSingleCheck) {
						// 单选
						this.checkedList = [item];
					} else {
						// 多选
						if (!this.checkedList.some((e) => e.code === item.code)) {
							// 不存在就写入
							this.checkedList.push(item);
						}
					}
				} else {
					// 过滤要删除的选项
					this.checkedList = this.checkedList.filter((e) => e.code !== item.code);
				}
				if (!checkAllFlag) {
					// 刷新选中状态
					this.validListItemChecked();
				}
				resolve();
			});
		},
		// 切换全选状态
		checkedAllChange() {
			this.checkedListLoading = true;
			this.list.forEach((e) => {
				!e.disabled ? (e.checked = this.currentCheckedAll) : '';
			});
			Promise.all(this.list.filter((e) => !e.disabled).map((item) => this.checkedChange(item, true))).then(() => {
				this.checkedListLoading = false;
				// 刷新选中状态
				this.validListItemChecked();
			});
		},
		// 删除选中
		deleteThisChecked(item) {
			// 过滤要删除的选项
			this.checkedList = this.checkedList.filter((e) => e.code !== item.code);
			// 刷新选中状态
			this.validListItemChecked();
		},
		// 清空选中
		clearAllChecked() {
			this.checkedList = [];
			// 刷新选中状态
			this.validListItemChecked();
		},
		cancel() {
			this.$emit('update:showOrgPicker', false);
		},
		submit() {
			// 未选中
			if (!this.checkedList.length) {
				this.Message.warning('请选择至少一项');
				return false;
			}
			// 单选只能选择一项
			if (this.isSingleCheck && this.checkedList.length > 1) {
				this.Message.warning('请只选择一项');
				return false;
			}
			// 搜索出来的label再还原回来
			this.checkedList = this.checkedList.map((item) => {
				if (item.isSearch) {
					item.label = item.labelReal;
					delete item.labelReal;
					delete item.isSearch;
				}
				return item;
			});
			let submitData = [];
			if (this.isPersonLevel) {
				if (this.isMergeUser) {
					// 合并用户-username用label显示用户来源类型
					submitData = this.checkedList.map(({ code: userId, label: username, sourceType }) => {
						return { userId: userId.split('-')[1], username, sourceType };
					});
					submitData = Array.from(new Set(submitData.map((e) => JSON.stringify(e)))).map((e) => JSON.parse(e));
				} else {
					// 不合并用户-username用originUserName
					submitData = this.checkedList.map(
						({
							code: userId,
							userId: originUserId,
							originUserName: username,
							userDeptCode: deptCode,
							userDeptName: deptName,
							showCheckedName: pathName,
							mobile,
							sourceType,
						}) => {
							return {
								userId,
								originUserId,
								username,
								deptCode,
								deptName: `[${this.userSystemList.find((e) => e.value === this.userSystemMap[sourceType])?.label}]${deptName}`,
								originDeptName: deptName,
								pathName,
								mobile,
								sourceType,
							};
						}
					);
				}
			} else {
				// deptName用label显示部门来源类型
				submitData = this.checkedList.map(({ code: deptCode, label: deptName, deptPath, showCheckedName: pathName, sourceType }) => {
					return { deptCode, deptName, deptPath, pathName, sourceType };
				});
			}
			this.$emit('updateCheckedData', submitData);
			this.cancel();
		},
		/** ----------------------------------按钮---------------------------------- */
	},
};
</script>
<style lang="less" scoped>
.content {
	height: 60vh;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	display: flex;
	> div {
		height: 100%;
	}
	.left {
		border-right: 1px solid #e8e8e8;
		width: 50%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		.search-bar {
			margin: 0 10px;
			display: flex;
			.search-input {
				width: calc(100% - 68px);
			}
			.search-button {
				margin-left: 10px;
			}
		}
		.breadcrumbs {
			margin: 10px 10px 0 10px;
			color: rgb(140, 140, 140);
			display: flex;
			.el-icon-office-building {
				font-size: 20px;
				margin-right: 10px;
			}
		}
		.list {
			margin: 10px 0 0 5px;
			padding-right: 8px;
			flex: 1;
			overflow: auto;
			.check-all {
				padding: 0 5px;
			}
			.list-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 5px;
				border-radius: 5px;
				::v-deep .el-checkbox {
					display: flex;
					align-items: center;
				}
				::v-deep .user-dept-checkbox.el-checkbox.is-disabled {
					.el-checkbox__input.is-disabled + span.el-checkbox__label {
						//color: #606266;
					}
				}
				.checkbox-label {
					white-space: normal;
				}
			}
			.list-item:hover {
				background: #f1f1f1;
			}
		}
	}
	.right {
		width: 50%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		.total-bar {
			display: flex;
			justify-content: space-between;
			color: #c75450;
			margin: 0 10px;
			> span:last-child {
				cursor: pointer;
			}
		}
		.checked-list {
			margin: 10px 0 0 10px;
			padding-right: 8px;
			flex: 1;
			overflow: auto;
			color: #606266;
			.checked-list-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 8px 5px;
				border-radius: 5px;
				.el-icon-close {
					font-size: 18px;
					margin-left: 20px;
					cursor: pointer;
				}
			}
			.checked-list-item:hover {
				background: #f1f1f1;
			}
			.empty-box {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}
}

.text-ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
	white-space: nowrap;
}
</style>
